import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import i18n from '@client/utils/i18n';
import { RecipeSection } from '@ledium/types';
import { Grid, MenuItem, Select } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import { SelectChangeEvent } from '@mui/material/Select';

interface SectionCircadianLengthSelectProps {
    sectionData: RecipeSection;
    onChange: (event: SelectChangeEvent<number>) => void;
}

const SectionCircadianLengthSelect = ({ sectionData, onChange }: SectionCircadianLengthSelectProps) => {
    const {
        pageState: { formData }
    } = usePageStore();

    return (
        <Grid item xs={4}>
            {formData.readOnly ? (
                <div>
                    {i18n('circadian_length')}: {sectionData.circadianLength} {i18n('circadian_length_hours')}
                </div>
            ) : (
                <>
                    <InputLabel shrink id="section-editor-circadian-length">
                        {i18n('circadian_length')}
                    </InputLabel>
                    <Select
                        labelId="section-editor-circadian-length"
                        onChange={onChange}
                        value={sectionData.circadianLength}
                        variant="outlined"
                        name="circadianLength"
                    >
                        {[...Array(24)].map((e, i) => (
                            <MenuItem key={`circadian-length-${i + 1}`} value={i + 1}>
                                {i + 1}
                            </MenuItem>
                        ))}
                    </Select>{' '}
                    {i18n('circadian_length_hours')}
                </>
            )}
        </Grid>
    );
};

export default SectionCircadianLengthSelect;
